import styled from "@emotion/styled";
import {Link} from "react-router-dom";
import {RebrandTheme} from "../../../common/models/common.models";
const backIcon = 'https://ti2020-qa-storage.tolunastart.com/tcp/images/backIcon.svg';

export const UserMenuPopper = styled.div`
    width: 212px;
    background-color: #FCFCFC;
    padding: 10px;
    margin-right:-5px;
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
`;

export const UserMenuOptions = styled.div`
    display: flex;
    flex-direction: column;
`;

export const UserMenuItem = styled.a<{disabled?: boolean, theme?: RebrandTheme}>`
    display:flex;
    align-items:center;
    color: #60738F;
    font-family: MuseoSans-300;
    font-size: 14px;
    padding: 10px;
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    text-decoration: none;
  
    &:hover{
       background-color:${props => props.disabled ? 'none' : '#f2f2f2'};
    }
  
    &:focus-visible {
       outline: 4px solid ${props => props.theme.header.outlineColor};
       outline-offset: -4px;
       border-radius: 8px;
    }
`;

export const LinkedUserMenuItem = styled(Link)<{disabled?: boolean, theme?: RebrandTheme}>`
    display:flex;
    align-items:center;
    color: #60738F;
    font-family: MuseoSans-300;
    font-size: 14px;
    padding: 10px;
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    text-decoration: none;
  
    &:hover{
       background-color:${props => props.disabled ? 'none' : '#f2f2f2'};
    }

    &:focus-visible {
       outline: 4px solid ${props => props.theme.header.outlineColor};
       outline-offset: -4px;
       border-radius: 8px;
    }
`;

export const UserMenuSeparator = styled.div`
    height: 1px;
    background-color: #ecf0f1;
`;

export const BackIcon = styled.div`
    background-image: url(${backIcon});
    background-position: center;
    background-size: cover;
    height: 13px;
    width: 13px;
    cursor: pointer;
    margin-right:7px;
`;
